interface Props {
  completed: number;
  total: number;
}

const STRProgressBar: React.FC<Props> = ({total, completed}) => {
  const completedPercentage = completed === 0 ? 0 : (completed / total) * 100;
  return (
    <div className="str-view-progress-bar">
      <div className="filled-bar" style={{width: `${completedPercentage}%`}} />
    </div>
  );
};

export default STRProgressBar;
